export default __webpack_public_path__ + "static/hero-image-cf7f7105bc0f885f167ed7a39434691a.png";